import {connect} from 'react-redux';

import {wrapActionCreator} from '../../helpers/reduxHelpers';
import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {Dispatch} from '../../store/appStore';
import {toggleRuleFromDragOptionsAction} from '../../store/data/localPreferences/localPreferencesActions';
import {getRuleFromDragOptions} from '../../store/data/localPreferences/localPreferencesSelectors';
import {updateIgnoreQuickRuleTagIdsAction} from '../../store/data/preferences/preferencesActions';
import {createQuickRuleAction} from '../../store/data/rules/rulesActions';
import {CreateTagRuleDialog} from './createTagRuleDialog';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  options: getRuleFromDragOptions,
}));

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    toggleRuleFromDragOptionsAction: wrapActionCreator(dispatch, toggleRuleFromDragOptionsAction),
    createQuickRuleAction: wrapActionCreator(dispatch, createQuickRuleAction),
    updateIgnoreQuickRuleTagIdsAction: wrapActionCreator(dispatch, updateIgnoreQuickRuleTagIdsAction),
  };
}

export const CreateTagRuleDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps) => ({
    ...stateProps.options,
    createRule: () => {
      if (!stateProps.options) {
        return;
      }

      const template = {tag: stateProps.options.tag, recipients: stateProps.options.recipients};
      dispatchProps.createQuickRuleAction(template);
    },
    onRequestClose: () => {
      if (!stateProps.options) {
        return;
      }
      dispatchProps.toggleRuleFromDragOptionsAction(stateProps.options, true);
    },
    ignoreFutureTagDrops: () => {
      if (!stateProps.options) {
        return;
      }
      dispatchProps.updateIgnoreQuickRuleTagIdsAction([stateProps.options.tag.id]);
    },
  }),
)(CreateTagRuleDialog);
